import { render, staticRenderFns } from "./ListaMonitoramentoAgricolaParaguai.vue?vue&type=template&id=36a8ccdd&scoped=true&lang=pug"
import script from "./ListaMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
export * from "./ListaMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
import style0 from "./ListaMonitoramentoAgricolaParaguai.vue?vue&type=style&index=0&id=36a8ccdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8ccdd",
  null
  
)

export default component.exports